type AppConfiguration = {
  apiBase: string;
  devLoginEnabled?: boolean;
  mixpanelToken?: string;
  gtmId?: string;
  mailchimpListId?: string;
};

const config: Record<string, AppConfiguration> = {
  local: {
    apiBase: "http://localhost:5000/v1",
    devLoginEnabled: true,
  },
  dev: {
    apiBase: "https://dev.api.accumbo.se/v1",
    devLoginEnabled: true,
    mixpanelToken: "f5dae56615c555eb82ea0e3ce8864b44",
  },
  dev2: {
    apiBase: "https://dev2.api.accumbo.se/v1",
    devLoginEnabled: true,
    mixpanelToken: "f5dae56615c555eb82ea0e3ce8864b44",
  },
  test: {
    apiBase: "https://test.api.accumbo.se/v1",
    devLoginEnabled: true,
    mixpanelToken: "f5dae56615c555eb82ea0e3ce8864b44",
    gtmId: "GTM-N9SVMKR",
    mailchimpListId: "50def18426",
  },
  test2: {
    apiBase: "https://test2.api.accumbo.se/v1",
    devLoginEnabled: true,
    mixpanelToken: "f5dae56615c555eb82ea0e3ce8864b44",
    gtmId: "GTM-N9SVMKR",
  },
  prod: {
    apiBase: "https://api.accumbo.se/v1",
    mixpanelToken: "136183e23cee224a32d48c9869192862",
    gtmId: "GTM-N9SVMKR",
    mailchimpListId: "316b581497",
  },
  ci: {
    apiBase: "https://test2.api.accumbo.se/v1",
    devLoginEnabled: true,
  },
};

const validEnvironments = Object.keys(config);

export const getEnvironment = (location: Partial<Location>) => {
  if (!location.host) {
    return "test";
  }

  if (
    import.meta.env.VITE_ENV &&
    validEnvironments.includes(import.meta.env.VITE_ENV as string)
  ) {
    return import.meta.env.VITE_ENV as string;
  }

  if (
    location.host.includes("localhost") ||
    location.host.includes("127.0.0.1")
  ) {
    return "local";
  }

  const regex = /^(test|dev|test2|dev2)\./;
  const match = location.host.match(regex);
  const detectedEnvironment = match && match[1];

  if (detectedEnvironment && validEnvironments.includes(detectedEnvironment)) {
    return detectedEnvironment;
  }

  return "prod";
};

export default config[
  import.meta.env.TEST ? "ci" : getEnvironment(window.location)
];
